exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.dial_container_1JhHX {\r\n    padding: 1rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n}\r\n\r\n.dial_dial-container_33mkQ {\r\n    position: relative;\r\n}\r\n\r\n.dial_dial-face_2aWlr, .dial_dial-handle_1OHhg, .dial_gauge_3bwaY {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    overflow: visible;\r\n}\r\n\r\n.dial_dial-face_2aWlr {\r\n    width: 100%;\r\n}\r\n\r\n.dial_dial-handle_1OHhg {\r\n    cursor: pointer;\r\n    width: 40px;\r\n    height: 40px;\r\n    /* Use margin to make positioning via top/left easier */\r\n    margin-left: calc(40px / -2);\r\n    margin-top: calc(40px / -2);\r\n}\r\n\r\n.dial_gauge-path_VQesE {\r\n    fill: var(--looks-transparent);\r\n    stroke: var(--looks-secondary);\r\n    stroke-width: 1px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "dial_container_1JhHX",
	"dial-container": "dial_dial-container_33mkQ",
	"dialContainer": "dial_dial-container_33mkQ",
	"dial-face": "dial_dial-face_2aWlr",
	"dialFace": "dial_dial-face_2aWlr",
	"dial-handle": "dial_dial-handle_1OHhg",
	"dialHandle": "dial_dial-handle_1OHhg",
	"gauge": "dial_gauge_3bwaY",
	"gauge-path": "dial_gauge-path_VQesE",
	"gaugePath": "dial_gauge-path_VQesE"
};